import { render, staticRenderFns } from "./rproduction-stations.vue?vue&type=template&id=05d15f6e"
import script from "./rproduction-stations.vue?vue&type=script&lang=ts"
export * from "./rproduction-stations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports